import { matchPath, PathMatch } from 'react-router'
import { BreadcrumbData } from 'use-react-router-breadcrumbs'

import { getHubRoutes, IHubRouteBuilder } from './hubRoutesRegistry'
import { ROUTES } from '@zing/shared/constants'

export interface IBreadcrumbLink {
  name: string
  path: string
}

const getBreadcrumbName = (route: IHubRouteBuilder): string =>
  typeof route.breadcrumb === 'function' ? route.breadcrumb() : route.breadcrumb

const addParentCrumb = (route: IHubRouteBuilder, filteredBreadcrumbs: IBreadcrumbLink[]): void => {
  const parentRoute = getHubRoutes().find((hubRoute) => hubRoute.path === route.breadcrumbParentPath)
  if (!parentRoute) return

  const parentName = getBreadcrumbName(parentRoute)
  if (!filteredBreadcrumbs.find(b => b.name === parentName)) {
    filteredBreadcrumbs.push({ name: parentName, path: `/hub${parentRoute.path}` })
  }
}

export const filterBreadcrumbs = (breadcrumbs: BreadcrumbData[]): IBreadcrumbLink[] => {
  const filteredBreadcrumbs: IBreadcrumbLink[] = []

  breadcrumbs.forEach((crumb) => {
    getHubRoutes().every((route: IHubRouteBuilder) => {
      let match
      if ((match = getCrumbMatchWithSystemRoute(route, crumb)) !== null) {
        const breadcrumbName = getBreadcrumbName(route)
        if (!filteredBreadcrumbs.find(b => b.name === breadcrumbName)) {
          addParentCrumb(route, filteredBreadcrumbs)
          filteredBreadcrumbs.push({ name: breadcrumbName, path: `/hub${String(match.pathname)}` })

          return false
        }
      }

      return true
    })
  })

  return filteredBreadcrumbs
}

export const isBreadcrumbEnabled = (pathname: string): boolean => {
  const currentRoute = getHubRoutes().find((route) =>
    matchPath({ path: route.path, caseSensitive: false, end: true }, pathname.replace('/hub', '')) !== null
  )

  return currentRoute?.showBreadcrumb ?? true
}

const getCrumbMatchWithSystemRoute = (route: any, crumb: any): PathMatch | null => {
  const pathname = crumb.location.pathname.replace('/hub', '')
  if (pathname.includes('/public-administration/') && route.path === ROUTES.HUB.COMPANY.ECOSYSTEM_STARTUP) {
    return null
  }
  return matchPath({ path: route.path, caseSensitive: false, end: false }, crumb.match.pathname.replace('/hub', ''))
}
